import { render, staticRenderFns } from "./antiLinkConfig.vue?vue&type=template&id=70a3b3b0"
import script from "./antiLinkConfig.vue?vue&type=script&lang=js"
export * from "./antiLinkConfig.vue?vue&type=script&lang=js"
import style0 from "./antiLinkConfig.vue?vue&type=style&index=0&id=70a3b3b0&prod&lang=css"
import style1 from "./antiLinkConfig.vue?vue&type=style&index=1&id=70a3b3b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports